import { WhiteLabelSubdomainInfo } from '../../api/budgetApiClient'
import { FluxStandardAction } from '../../types/fluxStandardAction'

export type GoToFlowAction = FluxStandardAction<
	'smartCheckFlowOrchestrator/goToFlow',
	{ applicantId: string }
>

export type GoToWhitelabelSubdomainLandingAction = FluxStandardAction<
	'smartCheckFlowOrchestrator/goToWhitelabelSubdomainLanding',
	null
>
export type WhitelabelSubdomainDataRetrievedSuccesfully = FluxStandardAction<
	'smartCheckFlowOrchestrator/WhitelabelSubdomainDataRetrievedSuccessfully',
	WhiteLabelSubdomainInfo
>

export type FlowEntryStatemachineAction =
	| GoToFlowAction
	| GoToWhitelabelSubdomainLandingAction
	| WhitelabelSubdomainDataRetrievedSuccesfully

export const goToFlow = (applicantId: string): GoToFlowAction => {
	return {
		type: 'smartCheckFlowOrchestrator/goToFlow',
		payload: {
			applicantId,
		},
	}
}

export function goToWhitelabelSubdomainLanding(): GoToWhitelabelSubdomainLandingAction {
	return {
		type: 'smartCheckFlowOrchestrator/goToWhitelabelSubdomainLanding',
		payload: null,
	}
}

export function whitelabelSubdomainDataRetrievedSuccesfully(
	payload: WhiteLabelSubdomainInfo,
): WhitelabelSubdomainDataRetrievedSuccesfully {
	return {
		type: 'smartCheckFlowOrchestrator/WhitelabelSubdomainDataRetrievedSuccessfully',
		payload,
	}
}
